export default __webpack_public_path__ + "static/media/conab_video_surrogate.04f60d6e.mp4";